import { FormGrid } from "components/UI/Form/FormGrid";
import {useGeneralForm} from "components/UI/GeneralForm/hooks/useGeneralForm";
import {
    FormDesignSelectSearchable
} from "components/UI/Selects/FormDesignSelectSearchable/FormDesignSelectSearchable.tsx";
import {usePaldockTranslation} from "hooks/usePaldockTranslation";
import {FormItem} from "react-hook-form-antd";

import {OfferApiFormEditFormData} from "../formSchema";


export const ApiFormDesignSection = () => {
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const { control, fieldNames } = useGeneralForm<OfferApiFormEditFormData>();

    return (
        <FormGrid cols={1}>
            <FormItem control={control} name={fieldNames.form_designs.name} label={tFields("form_design.label")}>
                <FormDesignSelectSearchable mode={"multiple"} allowClear={true} />
            </FormItem>
        </FormGrid>
    );
};
